module.exports = __webpack_public_path__ + "img/knowledge01.7f6ab3f4.jpeg";